/// <reference path="../../../../typings/index.d.ts" />
module Meevo.Plugins.MeevoMessenger{
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;
    import Guid = Meevo.Guid;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import MeevoFile = Meevo.Model.MeevoFile;
    import MeevoMessengerSettingsContext = Meevo.Plugins.MeevoMessengerSettings.MeevoMessengerSettingsContext;
    import AppointFinalStateEnum = Meevo.Model.AppointFinalStateEnum;
    import AppointStateEnum = Meevo.Model.AppointStateEnum;
    import PresetStatus = Meevo.Components.Controls.PresetStatus;

    export interface IRecipientRoutParams{
        label: string,
        actionState: MaintenanceFormState,
        initialEditSection: string,
        initialEditSubSection: string,
    }

    export interface Conversation {
        tenantId: number;
        locationId: number;
        id: Guid;
        externalId: string;
        classification: string;
        phoneNumber: string;
        clientId?: Guid;
        employeeId?: Guid;
        objectState: ObjectStateEnum;
        createdDateTime?: Date;
        updatedDateTime?: Date;
        followUp: boolean;
        hasMultipleContacts: boolean;
        entityVersion: number;
        lastInboundMessage: Message;
        lastOutboundMessage: Message;
        data: string;
    }

    export interface MeevoMessengerConversation extends Conversation {
        contactFirstName: string;
        contactMiddleName: string;
        contactLastName: string;
        isRestricted: boolean;
        isMultipleClients: boolean;
        isMultipleEmployees: boolean;
        fileGuid?: Guid;
        resourceType: number;
        contentType: string;
        meevoFile: any;
        isStorageUpdated: boolean;
        employeeCode: string;
        displayName: any;
        lastMessage: Message;
        displayNameFormat: any;
    }

    export interface Message {
        tenantId: number;
        locationId: number;
        id: Guid;
        externalId: string;
        conversationId: Guid;
        meevoSenderUserId?: Guid;
        body: string;
        createdDateTime?: Date;
        updatedDateTime?: Date;
        isDeleted: boolean;
        isRead: boolean;
        isInbound: boolean;
        hasAttachment: boolean;
        entityVersion: number;
        clientId?: Guid;
        employeeId?: Guid;
        classification: string;
        status?: number;
    }

    export interface MeevoMessengerMessage extends Message {
        senderUserName: string;
        isShowTimeLine?: any
        attachments?: any
    }

    export interface IConversationBodyRequest{
        isClientList: boolean;
        isNewMessage: boolean;
        filterPhoneNumber: string;
        filterFullName: string;
        isFollowUp: boolean;
        debug: boolean;
        dateStart: Date;
        dateEnd: Date;
        isLastInbound: boolean | null;
        criteria: {
            filter: string;
        },
        offset?: number;
        limit?: number;
        pageNumber?: number;
        itemsPerPage?: number;
        classification: MeevoMessengerClassificationAPI;
    }

    export interface IUnifiedDuplicatedUser{
        id: string;
        displayName: string;
    }

    export interface MessageFilter{
        name: string;
        type: MessageFilterOption;
    }

    export interface IDateFilter {
        name: string;
        status: PresetStatus;
    }

    export interface ISystemAutoReply{
        status: OperationModeEnum;
        delay: number;
    }

    export interface IHolidaysStatusForCurrentDays{
        isCurrentDayHoliday: boolean;
        isNextDayHoliday: boolean;
    }

    export interface IRecipientRouteParams {
        label: string,
        isRouting: boolean,
        type: RecipientRouteType,
        options: {
            actionState?: MaintenanceFormState,
            initialEditSection?: string,
            initialEditSubSection?: string,
            onClick?: Function
        }
    }

    export interface IUndeleteConversationOptions {
        isClientConversation?: boolean;
    }

    export interface IArrivalsAppointmentStatus {
        clientId: Guid,
        appointFinalStateEnum: number
    }

    export interface IAppointmentDataInfo {
        payingClientId: Guid,
        data: IAppointmentData[]
    }

    export interface IAppointmentData{
        appointmentHeaderId: Guid,
        serviceClientData: IAppointmentServiceClientData[]
    }

    export interface IAppointmentServiceClientData{
        id: Guid,
        firstName: string,
        lastName: string,
        serviceData: IAppointmentServiceData[]
    }

    export interface IAppointmentServiceData{
        appoinmentServiceId: Guid,
        appointFinalState: AppointFinalStateEnum,
        appointmentTransitionState: AppointStateEnum
    }

    export interface IAppointmentServiceCallbackData {
        recipientRouting: IRecipientRouteParams,
        appointmentData: IAppointmentServiceClientData
    }

    export interface IAppointmentSelectedClient{
        displayName: string,
        clientId: Guid
    }

    export interface IOptedOutDataRequest {
        phoneNumber: string;
        classification: string;
    }

    export enum MessageFilterOption{
        All,
        Unread,
        Marked
    }

    export enum OperationModeEnum{
        WorkingHours,
        OutsideBusinessHours,
        Holiday
    }

    export enum RecipientRouteType {
        DisplayClientProfile,
        DisplayClientNotes,
        DisplayFutureAppointments,
        DisplayTransactionHistory,
        AddNewClientProfile
    }

    export enum TextelUndeleteConversationModalTabsEnum {
        Client,
        Employee
    }

    export enum DeletedConversationStylesEnum {
        Client,
        Employee
    }

    export enum UndeleteConversationTypesEnum {
        Textel,
        Arrivals,
        ClientApp,
        TwoWaySms
    }

    export enum MessengersEnum{ //Order is NECESSARY (alphabetical)
        MeevoMessengerArrivals,
        MeevoMessengerClientApp,
        MeevoMessengerTextel,
        MeevoMessengerTwoWaySms,

    }

    export interface IMeevoMessengerModules {
        messengerName: string,
        messengerType: MessengersEnum,
        isShowSubs: boolean,
        meevoSecure: IMeevoSecureMessenger,
        icon: string,
        isPulsing: boolean,
        messengerSubModule: IMessengerSubModule[]
    }

    export interface IMessengerSubModule {
        messengerSubModuleName: string,
        isClient: boolean
    }

    export interface IMeevoSecureMessenger{
        securityKey?: string,
        secureDelete?: string,
        secureUnDelete?: string,
        secureSettings?: string
    }

    export interface SendMessageBody {
        userPhone: string;
        message: string;
        conversationId: Guid;
        classification: MeevoMessengerClassificationApiType;
        clientId?: string;
        employeeId?: string;
    }

    export interface IProfanityResponse {
        originalMessage: string,
        flagged: boolean,
        issuesDetected: any[],
        filteredMessages: string[]
    }

    export class MeevoMessengerClassificationAPI{
        public static get TEXTEL(): string {return 'Textel'};
        public static get ARRIVALS(): string {return 'Arrivals'};
        public static get MEGO(): string { return 'MeGo' };
        public static get TWOWAYSMS(): string { return 'Sms' };
    }

    export type MeevoMessengerClassificationApiType =
        | typeof MeevoMessengerClassificationAPI.TEXTEL
        | typeof MeevoMessengerClassificationAPI.ARRIVALS
        | typeof MeevoMessengerClassificationAPI.MEGO
        | typeof MeevoMessengerClassificationAPI.TWOWAYSMS;

    export enum AppointmentStatuses {
        CheckedIn = 164,
        CheckedOut = 2051,
        Cancelled = 2052,
        AppointmentNull = 0
    }

    export class MeevoMessengerMessages {
        public static get REFRESH_ARRIVALS_CONVERSATION(): string { return "refreshArrivalsConversation"; }
        public static get REFRESH_CLIENT_APP_CONVERSATION(): string { return "refreshClientAppConversation"; }
        public static get DELETING_CONVERSATION_CONFIRMATION(): string { return "deletingConversationConfirmation"; }
        public static get UNDELETE_CONVERSATION_MODAL(): string { return "undeleteConversationModal"; }
        public static get OPEN_MEEVOMESSENGER_SETTINGS(): string { return "openMeevoMessengerSettings"; }
        public static get OPEN_CLIENT_OR_EMPLOYEE_CONVERSATION(): string { return "openClientOrEmployeeConversation"; }
        public static get TOGGLE_AUTO_REPLIES(): string { return "toggleAutoReplies"; }
        public static get END_MODULE_PULSING(): string { return "endModulePulsing"; }
        public static get PROCESS_INBOUND_MESSAGE(): string { return "processInboundMessage"; }
        public static get CLEAR_TEXTEL_SETTINGS_AND_AUTH(): string { return "clearTextelSettingsAndAuth"; }
    }
}
